import styles from './DataLayoutCastFigure.module.css';
import React, { ReactNode } from 'react';
import Chips from '@he-novation/design-system/components/widgets/Chips/Chips';
import { FrontCastFolderChild } from '@he-novation/front-shared/types/cast.front-types';
import { timeToColonTimeCode } from '@he-novation/lib-timecodes';
import classNames from 'classnames';

import { FolderItemFolder } from '$components/DataLayout/DataLayoutFolder/DataLayoutFolderItem/FolderItemFolder';
import { FolderItemFigureContentImage } from '$components/DataLayout/DataLayoutFolder/FolderItemFigure/FolderItemFigure';
import { useCast } from '$hooks/useCast';

type PublicFolderFigureProps<T extends FrontCastFolderChild> = {
    className?: string;
    item: T;
    showDuration?: boolean;
};

const formatDuration = (duration: string) => duration.replace(/\..*/, '').replace(/^00?:/, '');

export function DataLayoutCastFigure<T extends FrontCastFolderChild>({
    className,
    item,
    showDuration
}: PublicFolderFigureProps<T>) {
    const { colors } = useCast();

    const duration =
        showDuration && item.type === 'file' && item.duration
            ? formatDuration(timeToColonTimeCode(item.duration / 1000, { frames: false }))
            : undefined;

    let figure: ReactNode;
    if (item.type === 'folder') {
        figure = (
            <FolderItemFolder iconColor={colors?.themeColorFaded50} className={styles.folder} />
        );
    } else if (item.type === 'file' && item.thumbnail) {
        figure = (
            <>
                <img src={item.thumbnail} alt="" />
                {duration && (
                    <Chips className="!absolute bottom-8 right-8 " color="#fff" background="#000">
                        {duration}
                    </Chips>
                )}
            </>
        );
    } else {
        figure = (
            <FolderItemFigureContentImage
                name={item.name}
                mimeType={item.mimeType}
                isPlayable={item.isPlayable}
                defaultIconColor={colors?.themeColorFaded50}
                className={styles.logo}
            />
        );
    }

    return (
        <div
            className={classNames(
                'public-folder-figure relative',
                item.type,
                className,
                styles.figure
            )}
        >
            {figure}
        </div>
    );
}
